import Button from "../Button/Button";
import './SectionHero.css'
import { Link } from "react-router-dom";


const SectionHero = () => {
  return (
    <section className="section-home">
      <div className="container-info">
        {" "}
        <h1>Cuida tu visión hoy</h1>
        <h2>Haz tu test visual en minutos</h2>
        <p className="paragrah uno">
          Un test de 3 minutos puede detectar a tiempo problemas que hoy no identificas.
        </p>
        <p className="paragrah">Gratis, sin registro y desde tu dispositivo.</p>
        <Link to={'./empezar'} className="link"><Button text={"Test Visual"} className={"degradado"} /></Link>
      </div>
    </section>
  );
};

export default SectionHero;
